'use client';

import { useSession } from 'next-auth/react';
import { Header } from '@/shared/components/Header';
import { Sidebar } from '@/shared/components/Sidebar';
import { NavLink } from '@/shared/lib/navigation';
import { LoginBoundary } from '@/features/auth/components/LoginBoundary';
import { ProgressToast } from '@/shared/components/ProgressToast';
import { WebSocketProvider } from '@/shared/providers/WebSocketProvider';

export function AppShell({ children, navLinks }: { children: React.ReactNode; navLinks: NavLink[] }) {
  const { status } = useSession();

  return (
    <WebSocketProvider>
      {status === 'authenticated' ? (
        <div className="flex min-h-screen flex-col">
          <Header />
          <div className="flex flex-1 overflow-hidden">
            <Sidebar navLinks={navLinks} />
            <main className="flex-1 overflow-auto p-6">
              <LoginBoundary>{children}</LoginBoundary>
            </main>
          </div>
          <ProgressToast />
        </div>
      ) : (
        <main className="min-h-screen w-full">
          <LoginBoundary>{children}</LoginBoundary>
        </main>
      )}
    </WebSocketProvider>
  );
}
